import { render, staticRenderFns } from "./FooterSearchListItem.vue?vue&type=template&id=18d56838&scoped=true&"
import script from "./FooterSearchListItem.vue?vue&type=script&lang=js&"
export * from "./FooterSearchListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d56838",
  null
  
)

export default component.exports